<template>
  <main class="recharge-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <span class="toolbar-title">充值记录</span>
      </div>
      <div class="desktop-only">
        <el-table :data="rechargeLogs" size="small" style="width: 100%" v-loading="loading">
          <el-table-column type="index" label="序号" :index="rowIndex" />
          <el-table-column label="时间">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="类型">
            <template>
              <el-tag type="success" size="small">充值</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="金额" >
            <template slot-scope="scope">
              <span style="color:#10b981;font-weight:600;">+¥ {{ $formatNumber(scope.row.amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作前余额" >
            <template slot-scope="scope">¥ {{ $formatNumber(scope.row.balanceBefore) }}</template>
          </el-table-column>
          <el-table-column label="操作后余额" >
            <template slot-scope="scope">¥ {{ $formatNumber(scope.row.balanceAfter) }}</template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mobile-only list-cards">
        <div class="list-card" v-for="(row, idx) in rechargeLogs" :key="idx">
          <div class="card-header">
            <div class="card-title">{{ $formatTime(row.createdAt) }}</div>
            <span style="color:#10b981;font-weight:700;font-size:15px;">+¥ {{ $formatNumber(row.amount) }}</span>
          </div>
          <div class="stats-row">
            <div class="stat-item">
              <div class="stat-value">¥ {{ $formatNumber(row.balanceBefore) }}</div>
              <div class="stat-label">操作前余额</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">¥ {{ $formatNumber(row.balanceAfter) }}</div>
              <div class="stat-label">操作后余额</div>
            </div>
          </div>
          <div class="meta-row" v-if="row.remark">
            <span>{{ row.remark }}</span>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination-bar"
        layout="total, prev, pager, next"
        small
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="onPageChange"
      />
    </section>
  </main>
</template>

<script>
export default {
  name: 'RechargeLogsPage',
  data() {
    return {
      rechargeLogs: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      loading: false
    }
  },
  computed: {
    rowIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    }
  },
  mounted() {
    this.fetchRechargeLogs()
  },
  methods: {
    async fetchRechargeLogs() {
      this.loading = true
      try {
        const res = await this.$http.get('/admin/billing/recharge-logs', {
          params: { page: this.currentPage, pageSize: this.pageSize }
        })
        this.rechargeLogs = res.records || []
        this.total = Number(res.total) || 0
      } catch {
        this.$message.error('加载充值记录失败')
      } finally {
        this.loading = false
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchRechargeLogs()
    }
  }
}
</script>

<style scoped>
.recharge-page {
  padding: 0 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.toolbar-title {
  font-size: 16px;
  font-weight: 800;
  color: var(--text);
  flex: 1;
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

/* mobile cards */
.list-cards { display: grid; gap: 14px; }
.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .recharge-page {
    padding: 0 12px 28px;
  }
  .table-panel {
    padding: 10px;
  }
  .pagination-bar {
    text-align: center;
  }
}

.list-card {
  padding: 14px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
}

.stats-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.stat-item {
  flex: 1;
  background: rgba(255,255,255,.04);
  border-radius: 8px;
  padding: 8px 10px;
  text-align: center;
}

.stat-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--text);
}

.stat-label {
  font-size: 10px;
  color: rgba(255,255,255,.35);
  margin-top: 2px;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 8px;
  border-top: 1px solid rgba(133,164,255,0.06);
  font-size: 12px;
  color: var(--muted-2);
}
</style>
